// extracted by mini-css-extract-plugin
module.exports = {"krProcess":"krProcess___17DRU"};